import { render, staticRenderFns } from "./RenderTranslatableText.vue?vue&type=template&id=24340f04&"
import script from "./RenderTranslatableText.vue?vue&type=script&lang=js&"
export * from "./RenderTranslatableText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports